import React, { Component } from 'react'

import MainLayout from '../../../mainLayout/index';
import { Link } from 'react-router-dom';
import PlusIcon from '../../../icons/plusicon';
import FpgMinusIcon from '../../../icons/fpgminusicon';
import DragIcon from '../../../icons/draggericon';
import ProgramImage from './../../../assets/images/user.jpg';
import TextField from '../../TextField';
import CalendarIcon from '../../../icons/calendaricon';
import SearchIcon from '../../../icons/searchicon';
import Select from 'react-select';
import service from "../../../services";
import Slider from "react-slick";
import DropdownMaster from '../../DropdownMaster';
import ErrorPopUp from '../../errorPopUp';
import ErrorScreeningPopUp from '../../errorScreeningPopUp'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//import AWS from "aws-sdk";
import AWS from "aws-sdk"; 
//moment import
import moment from "moment-timezone";
//  Date Picker
import DatePicker from "react-datepicker";
import _ from 'lodash'
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import CheckBox from '../../CheckBox';
import Loader from '../../loader';
import DeletefileIcon from '../../../icons/DeletefileIcon';
import AddFileIcon from '../../../icons/plusicon';
import PopUpCustomAll from './popUpCustomAll';
import TextEditor from '../../TextEditor';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import commonImage from '../../../commonImage';
import UploadForm from './UploadForm';
import FpgPlusIcon from '../../../icons/fpgplusicon';
import SimpleReactValidator from 'simple-react-validator';
import ModalMessage from '../../ModalMessage';
import DropdownMasterScreening from '../../DropdownMasterScreening'
import UploadImgicon from '../../../assets/images/upload_csv_icon.png'
import { SHORT_FILM_AVAILIBILITY } from "../../../cosntants";
//sweet alert
import swal from 'sweetalert';
import RecordPresenceBanner from '../../RecordPresenceBanner';
import ConflictSaveModal from '../../ConflictSaveModal';

let sub;

// fake data generator
const getItems = (count) =>
    Array.from({ length: count }, (v, k) => k).map((k) => ({
        id: `item-${k}`,
        content: `item ${k}`,
    }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const mapStateToProps = (state) => ({
    episodicShortProgramId: state.episodicShortProgramId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};

class EpisodicProgramCreate extends Component {
    constructor(props) {
        super(props)
        this._hasLeftPresence = false;

        this.state = {
            runTime: '',
            category: {value: '5fb39fe53b70f37b9e8c1335'},
            dateTimePreview: [],
            errorPopup: false,
            errorScreeningPopup: false,
            errorMsg: '',
            hours: { value: '7', label: '7' },
            minutes: { value: '30', label: '30' },
            state: { value: 'AM', label: 'AM' },
            selectshort: false,
            name: '',
            access: '',
            date: new Date(),
            films: [],
            film: [],
            dropList: [],
            shortProgrammeFilms: [],
            shortFilms: [],
            dropListInside: [],
            searchField: '',
            // shift72Id: '',
            sponsorLogo: '',
            isSponsor: false,
            isExplicitContent: false,
            messageModal: false,
            shortPopUp:false,
            explicitContent: EditorState.createEmpty(),
            longDescription: EditorState.createEmpty(),
            shortDescription: EditorState.createEmpty(),
            location: [],
            locationType:[
                {_id: '1', name: 'In-Person'},
                {_id: '2', name: 'Online'},
            ],
            locationType1:[
                // {_id: '1', name: 'In-Person'},
                {_id: '2', name: 'Online'},
            ],
            // screeningType: [
            //     {_id: '1', name: 'Premiere' },
            //     {_id: '2', name: 'Second Screening' },
            //     {_id: '3', name: 'Award winner' }
            // ], 
            screeningType:[],
            deleteImageId: '',
            sponsorLogoDetails: false,
            images: [
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
            ],
            dateTime: [
                {
                    // _id:Math.random(),
                    screeningType:{_id:'1',name: 'Premiere' },   
                    locations: [],
                    locationType:{_id:'1',name: 'In-Person' },
                    date:new Date(),
                    endDate:new Date(),
                    eventiveId:"",
                    waitListSlotValid:'',
                    maxWaitListSlots:0,
                    hideFromLive: false,
                    supressVoting: false,
                    openCaption: false,
                    accessibility:[],
                    interestTrack:[],
                    passBuckets:[],
                    isMyLibraryScreen:false,
                    start:{
                        date:new Date(),
                        hours: { value: '7', label: '7' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' },
                    },
                    end:{
                        date:new Date(),
                        hours: { value: '7', label: '7' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' },
                    },
                    emptyLocationError: '',
                    // shift72Id: '',
                }
            ],
            screeening:{},
            data:[
            {
                label:'Short Program',
                content:''
            },
            {
                label:'Episodic Pilot Showcase',
                content:''
            }],
            activetab: 1,
            genre: [],
            interestTrack: [],
            programDisabled: false,
            showConflictModal: false,
            editStartVersion: null,
        }
        this.apiserve = new service();
        this.validator = new SimpleReactValidator();
    }

    getCurrentFormData = () => {
        const normalizeDraftHtml = (editorState) => {
            if (!editorState || typeof editorState === 'string') return '';
            const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
        };

        return _.cloneDeep({
            name: this.state.name,
            runTime: this.state.runTime,
            access: this.state.access,
            category: this.state.category,
            shortProgrammeFilms: this.state.shortProgrammeFilms,
            shortFilms: this.state.shortFilms,
            sponsorLogo: this.state.sponsorLogo,
            isSponsor: this.state.isSponsor,
            isExplicitContent: this.state.isExplicitContent,
            explicitContent: normalizeDraftHtml(this.state.explicitContent),
            shortDescription: normalizeDraftHtml(this.state.shortDescription),
            longDescription: normalizeDraftHtml(this.state.longDescription),
            images: this.state.images,
            dateTime: this.state.dateTime,
            genre: this.state.genre,
            interestTrack: this.state.interestTrack,
        });
    }

    markEpisodicProgramEdited = () => {
        if (this.props.episodicShortProgramId && this.state.initialData) {
            const isDirty = !_.isEqual(this.state.initialData, this.getCurrentFormData());
            if (this.state.episodicProgramEdited !== isDirty) {
                this.setState({ episodicProgramEdited: isDirty });
            }
        }
    }

    updateState = (newState, callback) => {
        this.setState(newState, () => {
            this.markEpisodicProgramEdited();
            if (callback) {
                callback();
            }
        });
    }

    CancleShort = () => {
        this.updateState({
            selectshort: false,
            shortPopUp:false
        })
    }

    AddShort = () => {
        this.setState({
            selectshort: true,
            shortPopUp:true
        })
        this.apiserve.sendevent("film|dropList|short", {programType:'2'});
    }

    HideShortPopUp = () =>{
        this.setState({
            shortPopUp:false,
            selectshort: false,
        })
    }

    _handleBeforeUnload = () => {
        if (this._hasLeftPresence) return;
        this._hasLeftPresence = true;
        const recordId = this.props.episodicShortProgramId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|leave", { modelName: "shortProgramme", recordId });
        }
    }

    componentWillUnmount = () => {
        const recordId = this.props.episodicShortProgramId;
        window.removeEventListener('beforeunload', this._handleBeforeUnload);
        if (recordId && !this._hasLeftPresence) {
            this.apiserve.sendevent("RecordPresence|leave", { modelName: "shortProgramme", recordId });
        }
        sub.unsubscribe();
        this.props.ClearRecordPresence();
    };

    componentDidMount = () => {
        this.props.ClearRecordPresence();
        if(this.props.episodicShortProgramId){
            this.getShortProgramDetails();
        }
        this.apiserve.sendevent("user|sff|getAllInitial", {host:process.env.REACT_APP_HOST});
        const recordId = this.props.episodicShortProgramId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|join", { modelName: "shortProgramme", recordId });
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|sff|getAllInitial":
                    if(!response.error){
                        let screeningOption = []
                        response.data.film.screnningTypeList && response.data.film.screnningTypeList.length > 0 && response.data.film.screnningTypeList.forEach(screen => {
                            if(screen.type !== '7' && screen.type !== '8'){
                                screeningOption.push({ _id: screen.type, name: screen.name, screeningEventiveId: screen.eventiveTagId ,displayName:screen.displayName, locationType: screen.locationType, sortIndex: screen.sortIndex })
                            }
                        })
                        this.setState({
                            film: response.data.film,
                            location: response.data.film.locations,
                            screeningType: screeningOption
                        })
                    }
                    break;                    
                case "fpg|shortProgramme|getAllDetail":
                    if (!response.error) { 
                        //  boom = response.data?.date === '' ? this.state.dateTime : response.data?.date;
                        const dateTime = response.data.dateTime?.map(item => {
                            let hoursStart =moment(item.date).tz("US/Mountain").format('h'); 
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm');
                            let stateStart = moment(item.date).tz("US/Mountain").format('A');
                            let yearStart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthStart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let dateStart = moment(item.date).tz("US/Mountain").format('DD')

                            let hoursend =moment(item.endDate).tz("US/Mountain").format('h'); 
                            let minutesend = moment(item.endDate).tz("US/Mountain").format('mm');
                            let stateend = moment(item.endDate).tz("US/Mountain").format('A');
                            let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                            let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                            let dateend = moment(item.endDate).tz("US/Mountain").format('DD')
                            item.accessibility = item.accessibility.map(acc => { return { value: acc._id, label: acc.name, eventiveId: acc.eventiveId } })
                            item.interestTrack = (item.interestTrack || []).map(eventiveId => {
                                const track = this.state.film && this.state.film.interestTrack && this.state.film.interestTrack.find(t => t.eventiveId === eventiveId)
                                return track ? { value: track._id, label: track.name, eventiveId: track.eventiveId } : null
                            }).filter(Boolean)
                            const dTime = {
                                _id:item._id,
                                screeningType:item.screeningType === undefined ?  this.state.screeningType.find(item => item._id === '1') : {_id: item.screeningType, label: item.name },
                                // item.screeningType==='undefined' ?{_id:'1',name: 'Premiere' }:{_id: item.screeningType, label: item.name },
                                locationType: item.locationType === undefined ? {_id: "2", label: "Online" } : {_id: item.locationType, label: item.name },
                                locations: this.getLocations(item.locations),
                                date: new Date(yearStart, monthStart, dateStart),
                                endDate: new Date(yearend, monthend, dateend),
                                eventiveId:item.eventiveId,
                                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                                supressVoting:item.supressVoting ? item.supressVoting : false,
                                accessibility:item?.accessibility ? item?.accessibility : [],
                                interestTrack:item?.interestTrack ? item?.interestTrack : [],
                                passBuckets:item?.passBuckets ? item?.passBuckets : [],
                                openCaption:item?.accessibility ? item?.accessibility.length > 0 ? true : false : false,
                                waitListSlotValid:'',
                                locationEventiveId:item.locationEventiveId,
                                screeningEventiveId:item.screeningEventiveId,
                                start: {
                                    date: new Date(yearStart, monthStart, dateStart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: stateStart, label: stateStart },
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend },
                                },
                                // shift72Id:item.shift72Id
                            }
                            return dTime;
                        })

                        const dateTimePreview = response.data.dateTime?.map(item => {
                            let hoursStart =moment(item.date).tz("US/Mountain").format('h'); 
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm');
                            let stateStart = moment(item.date).tz("US/Mountain").format('A');
                            let yearStart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthStart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let dateStart = moment(item.date).tz("US/Mountain").format('DD')

                            let hoursend =moment(item.date).tz("US/Mountain").format('h'); 
                            let minutesend = moment(item.date).tz("US/Mountain").format('mm');
                            let stateend = moment(item.date).tz("US/Mountain").format('A');
                            let yearend = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthend = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let dateend = moment(item.date).tz("US/Mountain").format('DD')
                            item.accessibility = item.accessibility.map(acc => { return { value: acc._id, label: acc.name, eventiveId: acc.eventiveId } })
                            item.interestTrack = (item.interestTrack || []).map(eventiveId => {
                                const track = this.state.film && this.state.film.interestTrack && this.state.film.interestTrack.find(t => t.eventiveId === eventiveId)
                                return track ? { value: track._id, label: track.name, eventiveId: track.eventiveId } : null
                            }).filter(Boolean)
                            const dTime = {
                                _id:item._id,
                                screeningType:item.screeningType === undefined ?  this.state.screeningType.find(item => item._id === '1') : {_id: item.screeningType, label: item.name },
                                // item.screeningType==='undefined' ?{_id:'1',name: 'Premiere' }:{_id: item.screeningType, label: item.name },
                                locationType: item.locationType === undefined ? {_id: "2", label: "Online" } : {_id: item.locationType, label: item.name },
                                locations: item.locations,
                                date: new Date(yearStart, monthStart, dateStart),
                                endDate: new Date(yearend, monthend, dateend),
                                eventiveId:item.eventiveId,
                                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                                supressVoting:item.supressVoting ? item.supressVoting : false,
                                accessibility:item?.accessibility ? item?.accessibility : [],
                                interestTrack:item?.interestTrack ? item?.interestTrack : [],
                                passBuckets:item?.passBuckets ? item?.passBuckets : [],
                                openCaption:item?.accessibility ? item?.accessibility.length > 0 ? true : false : false,
                                waitListSlotValid:'',
                                locationEventiveId:item.locationEventiveId,
                                screeningEventiveId:item.screeningEventiveId,
                                start: {
                                    date: new Date(yearStart, monthStart, dateStart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: stateStart, label: stateStart },
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend },
                                },
                                // shift72Id:item.shift72Id
                            }
                            return dTime;
                        })

                        let images = response.data.images.map(item => {
                            const imag = {
                                _id: Math.random(),
                                inSite: item.inSite,
                                link: item.link
                            }
                            return imag;
                        })

                        // const year = moment(response.data.date).tz("US/Mountain").format('YYYY')
                        // const month = moment(response.data.date).tz("US/Mountain").format('MM') - 1
                        // const date = moment(response.data.date).tz("US/Mountain").format('DD')
                        // var shortProgramDate = new Date(year, month, date)
                        // var hours = moment(response.data.date).tz("US/Mountain").format('h');
                        // var minutes = moment(response.data.date).tz("US/Mountain").format('mm');
                        // var state = moment(response.data.date).tz("US/Mountain").format('A');
                       if(response.data.explicitContent){
                            const blocksFromHtml = htmlToDraft(response.data.explicitContent);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const explicitContent = EditorState.createWithContent(contentState);
                            this.setState({ explicitContent: explicitContent})
                       }
                       if(response.data?.shortDescription){
                            const blocksFromHtml = htmlToDraft(response.data.shortDescription);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const shortDescription = EditorState.createWithContent(contentState);
                            this.setState({ shortDescription})
                            
                        }
                        if(response.data?.longDescription){
                            const blocksFromHtml = htmlToDraft(response.data.longDescription);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const longDescription = EditorState.createWithContent(contentState);
                            this.setState({ longDescription})
                        }
                        let shortProgrammeFilmsData = response.data.shortProgrammeFilms.map(item => {
                            item.film.isUnavailable = (response.data.shortFilms && response.data.shortFilms.length > 0) ? response.data.shortFilms.filter(film => film.filmId === item.film._id)[0]?.isUnavailable : false
                            return item
                        })
                        var genreData = response?.data && response?.data?.genre.map(item => {
                            var genre = {
                                value: item._id, label: item.name
                            }
                            return genre
                        })

                        var interestTrackData = response?.data && (response?.data?.interestTrack || []).map(item => {
                            const id = typeof item === 'string' ? item : item._id
                            const track = this.state.film && this.state.film.interestTrack && this.state.film.interestTrack.find(t => t._id === id)
                            return track ? { value: track._id, label: track.name } : null
                        }).filter(Boolean)
                        this.setState({
                            name: response.data.name,
                            runTime: response.data.runTime,
                            access: { value: response.data.access && response.data.access._id, label: response.data.access && response.data.access.name },
                            // date: shortProgramDate,
                            // hours: { value: hours, label: hours },
                            // minutes: { value: minutes, label: minutes },
                            // state: { value: state, label: state },
                            shortProgrammeFilms: shortProgrammeFilmsData,
                            shortFilms: response.data.shortFilms,
                            loaderFlag: false,
                            // shift72Id: response.data.shift72Id,
                            sponsorLogo: response.data.sponsorLogo,
                            isSponsor: response.data.isSponsor,
                            isExplicitContent: response.data.isExplicitContent,
                            dateTime: dateTime,
                            dateTimePreview: dateTimePreview,
                            images: images,
                            genre: genreData || [],
                            interestTrack: interestTrackData || [],
                            getLastUpdated: {
                                updatedAt: response?.data?.updatedAt,
                                updatedBy: {
                                    fname: response?.data?.updatedBy?.fname,
                                    lname: response?.data?.updatedBy?.lname
                                }
                            },
                            ...(response?.data?.updatedAt ? { editStartVersion: response.data.updatedAt } : {})
                        }, () => {
                            this.setState({ initialData: this.getCurrentFormData(), episodicProgramEdited: false });
                        })
                        // moment(shortProgramDate).format('h')
                        // moment(shortProgramDate).format('mm')
                        // moment(shortProgramDate).format('A')
                    }
                    break;
                case "film|dropList|short":
                    if (!response.error) {
                        // let inpersonProgram=[]
                        response.data &&
                            response.data.map((item) => {
                                item.value = false;
                            });
                        const result = response.data.filter(o1 =>
                            !this.state.shortProgrammeFilms.find(o2 => o1._id === o2.film._id)
                        );

                        // result.map(item => {
                        //     item.dateTime.map((item1) => {
                        //         if (item1.locationType === '1' || item1.locationType === 1) {
                        //             inpersonProgram.push(item)
                        //         }
                        //     })
                        // }
                        // )

                        this.setState({
                            dropList: result
                            // selectedTitle: null
                        })
                    }
                    break;
                case "fpg|shortProgramme|edit":
                    if (response.error) {
                        if (response.data?.error === 'CONFLICT_DETECTED') {
                            this.props.SetRecordConflict({
                                userName: 'another user',
                                updatedAt: response.data?.data?.currentUpdatedAt
                            });
                            this.setState({ showConflictModal: true, loaderFlag: false });
                        } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            loaderFlag: false,
                            programDisabled: false
                        })
                        }
                    } else {
                        this.setState({
                            loaderFlag: false,
                            programDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Updated successfully.')
                            this.getShortProgramDetails();
                            this.setState({
                                programDisabled: false,
                                loaderFlag: false,
                                episodicProgramEdited: false
                            })
                        }
                    }
                    break;
                case "fpg|shortProgramme|previewShortProgramme":
                    if (!response.error) {
                        this.setState({ loaderFlag: false,programDisabled: false})
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'episodic-program-events-preview?id=' + response.data._id);
                    }
                    break;
                case "fpg|shortProgramme|add":
                    if (response.error) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            loaderFlag: false,
                            programDisabled: false
                        })
                    } else {
                        this.setState({
                            loaderFlag: false,
                            programDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Created successfully.')
                            this.props.history.push('/short-program-list')
                        }
                    }
                    break;
                case "RecordPresence|join":
                    if (!response.error && response?.data?.recordUpdatedAt) {
                        this.setState({ editStartVersion: response.data.recordUpdatedAt });
                    }
                    break;
                case "RecordPresence|viewersUpdate":
                    if (response?.data?.recordId === this.props.episodicShortProgramId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                case "RecordPresence|recordUpdated":
                    if (response?.data?.recordId === this.props.episodicShortProgramId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
                        const updatedBy = response?.data?.updatedBy;
                        this.props.SetRecordConflict({
                            userName: updatedBy ? `${updatedBy?.fname || ''} ${updatedBy?.lname || ''}`.trim() : 'another user',
                            updatedAt: response?.data?.updatedAt
                        });
                    }
                    break;
                default:
                    break;
            }
        });
    };

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.shortProgrammeFilms];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                _id: Math.random(),
                shortProgramme: '',
                film: {
                    images: {
                        inSite: '',
                        link: ''
                    },
                    runTime: '',
                    title: '',
                    _id: ''
                }
            });
        });

        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.updateState({ shortProgrammeFilms: arr });
    };

    getShortProgramDetails = () => {
        this.setState({
            loaderFlag: true
        })
        const data = {
            shortProgrammeId: this.props.episodicShortProgramId
        }
        // this.apiserve.sendevent("user|sff|getAllInitial", {});
        this.apiserve.sendevent("fpg|shortProgramme|getAllDetail", data);
    };

    onInputChange = (e) => {
        this.updateState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeDate = (date, id,dateType) => {
        this.updateState({})
        this.state.dateTime.forEach(event => {
          if(event._id === id)
          {
            // event.date = date
            if(dateType === 'startDate'){
                event.start.date = date
                event.date = date
            }else if(dateType === 'endDate'){
                event.end.date = date
                event.endDate = date
            }
          }
        });
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    errorMsgPopupOk = () => {
        this.setState({
            errorScreeningPopup: false
        })
        this.props.history.push('/short-program-list')
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name }
        })
    }

    handleUnavailable = (e,id) => {
        this.state.shortProgrammeFilms.forEach((item, i) => {
            if(item.film._id === id){
                item.film.isUnavailable = e.target.value
            }
        })
        this.updateState({})
    }

    handleTimeStartHours = (e,id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.start.hours = e 
            }
        })
        this.updateState({})
    }

    handleTimeStartMin = (e, id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.start.minutes = e 
            }
        })
        this.updateState({})
    }

    handleTimeStartStamps = (e , id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.start.state = e 
            }
        })
        this.updateState({})
    }

    handleTimeEndHours = (e,id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.end.hours = e 
            }
        })
        this.updateState({})
    }

    handleTimeEndMin = (e, id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.end.minutes = e 
            }
        })
        this.updateState({})
    }

    handleTimeEndStamps = (e , id) => {
        this.state.dateTime.forEach((item, i) => {
            if(i  === id){
                item.end.state = e 
            }
        })
        this.updateState({})
    }

    shortProgramCheck = (e, item) => {
        const { name, checked } = e.target
        let chkarray = [...this.state.dropListInside,item]
        if (checked) {
            this.updateState({
                dropListInside: chkarray
            })
                this.forceUpdate();
            
        } else {

            var filteredShortProgram = this.state.dropListInside.filter(_ => _._id !== item._id)
            this.updateState({
                dropListInside: filteredShortProgram
            });

        }
    }

    selectedShortFilm = (e) => {
        e.preventDefault()
        // var newProgram = _.uniqBy(this.state.dropListInside, '_id')
        var newProgram = this.state.dropListInside

        var shortProgrammeFilms = this.state.shortProgrammeFilms;
        for (let i = 0; i < newProgram.length; i++) {

            var films = {
                film: {...newProgram[i], isUnavailable: false},
            };
            shortProgrammeFilms.push(films);
            shortProgrammeFilms = _.uniqBy(shortProgrammeFilms, 'film._id');
            if (newProgram.length === 1 + i) {
                this.HideShortPopUp()
                this.updateState({
                    shortProgrammeFilms: shortProgrammeFilms,
                    selectshort: false
                })
            }else{
                this.updateState({
                    selectshort: false
                })
            }
        }
    }

    //Search Data
    onSearchFilter = (e) => {
        this.updateState({
            [e.target.name]: e.target.value,
        }, () => {
            var data = {}
            if (this.state.searchField.length) {
                data = {
                    filter: this.state.searchField,
                    programType:'2'
                }
            }
            this.apiserve.sendevent("film|dropList|short", data);
        });
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    checkCustomValidation = () => {
        
        const { dateTime } = this.state;

        let errorFlag = 0;

        dateTime.length > 0 && dateTime.map(date=>{
            const type = date.locationType._id || date.locationType.value;
            
            if(type === "1" || type === "3")
            {
                try {
                    if(date.locations === null || date.locations.length === 0 || date.locations.length === 'undefined' || date.locations === false)
                    {
                        date.emptyLocationError = 'Location is required for all screening times.'
                        errorFlag += 1;
                    }
                    else
                    {
                        date.emptyLocationError = ''
                    }
                } catch (error) {
                    date.emptyLocationError = ''
                }
            }  
            else{
                date.emptyLocationError = ''
            }          
        })

        this.setState({})
        return errorFlag > 0 ? false : true;
    }

    submitShortProgram = (e, isPreview) => {
        let waitlistvalid = false
        this.state.dateTime.map((date) => {
            if(date.waitListSlotValid !== ''){
                waitlistvalid = true
            }
        })
        var filmID = this.state.shortProgrammeFilms.map((item) => {
            return item && item.film && item.film._id
        })

        var eventiveID = this.state.shortProgrammeFilms.map((item) => {
            return item && item.film && item.film.eventiveId
        })

        var shortFilms = this.state.shortProgrammeFilms.map((item) => {
            return item && item.film && {filmId:item.film._id,isUnavailable:JSON.parse(item.film.isUnavailable) || false}
        })

        // var shortProgramFinal = new Date(this.state.date);
        // shortProgramFinal.setHours( this.state.state.value === 'PM' || this.state.state.value === 'pm' ? parseInt(this.state.hours.value) + 12: parseInt(this.state.hours.value), this.state.minutes.value);
        var shortProgramFinal = new Date(this.state.date);
        shortProgramFinal.setHours(this.state.state.value === 'PM' || this.state.state.value === 'pm' ? parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) : parseInt(this.state.hours.value) + 12 : parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) - 12 : parseInt(this.state.hours.value), this.state.minutes.value);
        const name = this.state.explicitContent ? convertToRaw(this.state.explicitContent.getCurrentContent()) : ''
        const  markup= draftToHtml(name);
        const shortdes = this.state.shortDescription ? convertToRaw(this.state.shortDescription.getCurrentContent()) : ''
        const  short= draftToHtml(shortdes);
        const longdes = this.state.longDescription ? convertToRaw(this.state.longDescription.getCurrentContent()) : ''
        const  long= draftToHtml(longdes);

        const dateTime = this.state.dateTime.map(item => {
            let defaultScreening = this.state.screeningType.find(screen => screen._id === (item.screeningType._id || item.screeningType.value))
            item.date.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
            item.endDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
            const dTime = {
                _id: item._id !== undefined ? item._id.toString() : Math.random().toString(),
                screeningType:  item.screeningType === undefined ?  this.state.screeningType.find(item => item._id === '1') : item && item.screeningType && item.screeningType._id || item && item.screeningType && item.screeningType.value,
                locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                locations: item.locations.value ? [item.locations.value] : item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                date: this.getMtTime(item.date),
                endDate: this.getMtTime(item.endDate),
                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                supressVoting:item.supressVoting ? item.supressVoting : false,
                screeningEventiveId:item.screeningEventiveId || defaultScreening.screeningEventiveId,
                accessibility:item?.accessibility ? item?.accessibility?.map(acc => acc.eventiveId) : [],
                interestTrack:item?.interestTrack ? item?.interestTrack?.map(it => it.eventiveId) : [],
                passBuckets:item?.passBuckets ? item?.passBuckets : [],
                // hours:item.hours.value,
                // minutes:item.minutes.value,
                // state:item.state.value,
                // shift72Id:item.shift72Id,
            }
            let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dTime ;
            return editDateTime;
        })

        var genreData = this.state.genre && this.state.genre.map(e => e.value)
        var interestTrack = this.state.interestTrack && this.state.interestTrack.map(e => e.value)

        if(this.validator.allValid() && this.checkCustomValidation() && !waitlistvalid){
            this.setState({ loaderFlag: true, programDisabled: true })
            if (!isPreview && this.props.episodicShortProgramId && this.props.recordConflict) {
                this.setState({ showConflictModal: true, loaderFlag: false, programDisabled: false });
                return;
            }
            if (this.props.episodicShortProgramId) {
                let shortProgramEdit = {
                    "shortProgrammeId": this.props.episodicShortProgramId,
                    expectedUpdatedAt: this.state.editStartVersion || undefined,
                    "name": this.state.name,
                    "access": this.state.access && this.state.access.value,
                    "dateTime": dateTime,//this.getMtTime(shortProgramFinal),
                    "films": filmID,
                    // "shift72Id": this.state.shift72Id,
                    "sponsorLogo": this.state.sponsorLogo,
                    "isSponsor": this.state.isSponsor,
                    "isExplicitContent": this.state.isExplicitContent,
                    "explicitContent": markup,
                    shortDescription: short,
                    longDescription: long,
                    images: this.state.images,
                    category: this.state.category.value,
                    runTime:this.state.runTime,
                    "eventiveFilms":eventiveID,
                    programType:'2',
                    shortFilms:shortFilms,
                    genre: genreData,
                    interestTrack: interestTrack,
                    // screening:this.state.screening
                }
                isPreview ? this.apiserve.sendevent("fpg|shortProgramme|previewShortProgramme", shortProgramEdit) : this.apiserve.sendevent("fpg|shortProgramme|edit", shortProgramEdit);
            } else {
                let shortProgramAdd = {
                    "name": this.state.name,
                    "access": this.state.access && this.state.access.value,
                    "dateTime":   dateTime,  //this.getMtTime(shortProgramFinal),
                    "films": filmID,
                    // "shift72Id": this.state.shift72Id,
                    "sponsorLogo": this.state.sponsorLogo,
                    "isSponsor": this.state.isSponsor,
                    "isExplicitContent": this.state.isExplicitContent,
                    "explicitContent": markup,
                    shortDescription: short,
                    longDescription: long,
                    images: this.state.images,
                    category: this.state.category.value,
                    runTime:this.state.runTime,
                    "eventiveFilms":eventiveID,
                    programType:'2',
                    shortFilms:shortFilms,
                    genre: genreData,
                    interestTrack: interestTrack,
                }
                isPreview ? this.apiserve.sendevent("fpg|shortProgramme|previewShortProgramme", shortProgramAdd) : this.apiserve.sendevent("fpg|shortProgramme|add", shortProgramAdd);
            }
        }else{
            this.checkCustomValidation();
                this.setState({
                    messageModal: true,
                    programDisabled: false
                })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
            deleteImagePopup: false
        })
    }

    previewRecordTalk = () => {
        const filmID = this.state.shortProgrammeFilms.map((item) => {
            return item && item.film && item.film._id
        })
        const shortProgramFinal = new Date(this.state.date);
        shortProgramFinal.setHours(this.state.state.value === 'PM' || this.state.state.value === 'pm' ? parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) : parseInt(this.state.hours.value) + 12 : parseInt(this.state.hours.value) === 12 ? parseInt(this.state.hours.value) - 12 : parseInt(this.state.hours.value), this.state.minutes.value);
        const name = this.state.explicitContent ? convertToRaw(this.state.explicitContent.getCurrentContent()) : ''
        const  markup= draftToHtml(name);
        const shortdes = this.state.shortDescription ? convertToRaw(this.state.shortDescription.getCurrentContent()) : ''
        const  short= draftToHtml(shortdes);
        const longdes = this.state.longDescription ? convertToRaw(this.state.longDescription.getCurrentContent()) : ''
        const  long= draftToHtml(longdes);


        const dateTime = this.state.dateTime.map(item => {
            let defaultScreening = this.state.screeningType.find(screen => screen._id === (item.screeningType._id || item.screeningType.value))
            item.date.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
            item.endDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
            const dTime = {
                _id: item._id !== undefined ? item._id.toString() : Math.random().toString(),
                screeningType:  item.screeningType === undefined ?  this.state.screeningType.find(item => item._id === '1') : item && item.screeningType && item.screeningType._id || item && item.screeningType && item.screeningType.value,
                locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                locations:  item.locations.value ? [item.locations.value] : item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                date: this.getMtTime(item.date),
                endDate: this.getMtTime(item.endDate),
                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                supressVoting:item.supressVoting ? item.supressVoting : false,
                screeningEventiveId:item.screeningEventiveId || defaultScreening.screeningEventiveId,
                accessibility:item?.accessibility ? item?.accessibility?.map(acc => acc.eventiveId) : [],
                interestTrack:item?.interestTrack ? item?.interestTrack?.map(it => it.eventiveId) : [],
                passBuckets:item?.passBuckets ? item?.passBuckets : [],
                // hours:item.hours.value,
                // minutes:item.minutes.value,
                // state:item.state.value,
                // shift72Id:item.shift72Id,
            }
            let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dTime ;
            return editDateTime;
        })
        let editTalkAndEvent = {};
        // if(this.props.shortProgramId){
            editTalkAndEvent = {
                "shortProgrammeId": this.props.episodicShortProgramId,
                    "name": this.state.name,
                    "access": this.state.access && this.state.access.label,
                    "dateTime": dateTime,//this.getMtTime(shortProgramFinal),
                    longDescription: long,
                    images: this.state.images,
                    shortProgrammeFilms: this.state.shortProgrammeFilms
            }
        // }
        let previewRecordTalkEvents = this.apiserve.encrypt(editTalkAndEvent)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'episodic-program-events-preview?data=' + previewRecordTalkEvents);

    }

    removeShortProgram = (e, id) => {
        const filteredShortProgram = this.state.shortProgrammeFilms.filter(item =>
            item && item.film && item.film._id ? item.film._id !== id : undefined
        )
        const filteredShortProgram1 = this.state.dropListInside.filter(item =>
            item && item.film && item.film._id ? item.film._id !== id : undefined
        )
        this.updateState({
            shortProgrammeFilms: filteredShortProgram,
            dropListInside: filteredShortProgram1
        });

    }

    clearAllForm = () => {
        this.setState({
            name: "",
            access: {value:'',label:''},
            date: new Date(),
            dateTime:[{
                // _id:Math.random(),
                screeningType:  this.state.screeningType.find(item => item._id === '1'),
                locationType: { _id: '1', name: 'In-Person' },
                locations: [],
                date:new Date(),
                endDate:new Date(),
                eventiveId:"",
                waitListSlotValid:'',
                maxWaitListSlots:0,
                hideFromLive: false,
                supressVoting: false,
                openCaption: false,
                accessibility:[],
                interestTrack:[],
                passBuckets:[],
                isMyLibraryScreen:false,
                start: {
                    date: new Date(),
                    hours: { value: '7', label: '7' },
                    minutes: { value: '30', label: '30' },
                    state: { value: 'AM', label: 'AM' }
                },
                end: {
                    date: new Date(),
                    hours: { value: '7', label: '7' },
                    minutes: { value: '30', label: '30' },
                    state: { value: 'AM', label: 'AM' }    
                }  
              }],
            hours: '7',
            minutes: "30",
            state: "AM",
            explicitContent:'',
            longDescription:'',
            shortDescription:'',
            isExplicitContent:false,
            runTime:'',
            images: [
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id:Math.random(),
                    link: "",
                    inSite: ""
                },
            ],
            shortProgrammeFilms: [],
        })
        // setTimeout(() => {
            this.props.EpisodicShortProgramEditData('')
        // },100)
        this.props.history.push({
            pathname: '/program'
        })

    }

    backToListShortProgram = () => {
        this.props.history.push({
            pathname: '/short-program-list'
        })
    }

    handleImageAwardSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            file: file,
          },()=>{
            this.uploadSponsorLogo.value =''

            const fileList = Math.round((file && file.size / 1024));
            if (fileList > 10240) {        
              this.setState({
                errorPopup:true,
                errorMsg: 'Please upload a file smaller than 10MB'           
               })
                return false;
            } 
            if(file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ){
                setTimeout(() => {
                    this.imageUploadAwardSponsorLogo(file);
                }, 1000)
            }else{
                this.setState({
                    errorPopup:true,
                    errorMsg: 'Please upload a file for PNG,JPG or JPEG'           
                })
            }      
        })
        }
    }

    deleteImagePopup = () => {
        if(this.state.sponsorLogoDetails){
            this.updateState({
                deleteImagePopup:false,
                sponsorLogo:'',
            })
        }
        if(this.state.images.length){
            this.state.images.forEach(image => {
                if(image._id === this.state.deleteImageId){
                    image.inSite = ''
                }
            });
            this.updateState({
                deleteImagePopup: false
            })
        }
        this.updateState({
            sponsorLogoDetails: false,
            deleteImageId: ''
        })
    }

    closeAdminUser = () => {
        this.setState({
         deleteImagePopup:false
        });
    };

    deleteImageSponsorLogo(){
        this.setState({
            sponsorLogoDetails: true,
            deleteImagePopup:true,
        })
    }

    handleImageSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
          },()=>{
            this.uploadSponsorLogo.value =''
            const fileList = Math.round((file && file.size / 1024));
            if (fileList > 10240) {        
              this.setState({
                errorPopup:true,
                errorMsg: 'Please upload a file smaller than 10MB'           
               })
                return false;
            } 
            if(file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ){
                setTimeout(() => {
                    this.imageUploadSponsorLogo(file,event.target.result);
                }, 1000)
            }else{
                this.setState({
                    errorPopup:true,
                    errorMsg: 'Please upload a file for PNG,JPG or JPEG'           
                })
            }      
        })
        }
    }

    imageUploadSponsorLogo = (file, img) => {
        this.setState({ImagePreloaderSponsorLogo:true})
        var fileSet= commonImage(file,false,'',img)
        fileSet.then((value) => {
           this.updateState({
                sponsorLogo:value,
                ImagePreloaderSponsorLogo:false
           })  
        })
    }

    handleCheck = (e) => {
        const { name, checked } = e.target;
           this.updateState({
               [name]:checked
           })
                
    }
    handleLiveCheck = (e,id) => {
        const { name, checked } = e.target;
        if(name === 'hideFromLive'){
            let newDateTime = this.state.dateTime
            newDateTime.map((item) => {
                if(item._id === id){
                    item.hideFromLive = checked
                }
            })
            this.updateState({
                dateTime:newDateTime  
            })
        } else if(name === 'openCaption'){
            let updateDateTime = this.state.dateTime
            let accessibility = this.state.film && this.state.film.accessibility.filter(_ => _.identifier === 'opencaption')
            updateDateTime.map((item) => {
                if(item._id === id){
                    item.openCaption = !item.openCaption
                    item.accessibility = item.openCaption ? [accessibility[0]?.eventiveId] : []
                }
            })
            this.updateState({
                dateTime:updateDateTime  
            })
        } else if(name === 'supressVoting'){
            let newDateTime = this.state.dateTime
            newDateTime.map((item) => {
                if(item._id === id){
                    item.supressVoting = checked
                }
            })
            this.updateState({
                dateTime:newDateTime  
            })
        }
                
    }

    handleChangenAccessibilityScreening = (accessibility,id) => {
        let newDateTime = this.state.dateTime
        newDateTime.map((item) => {
            if(item._id === id){
                item.accessibility = accessibility
            }
        })
        this.updateState({
            dateTime:newDateTime
        })
    };

    handleChangenInterestTrackScreening = (interestTrack,id) => {
        let newDateTime = this.state.dateTime
        newDateTime.map((item) => {
            if(item._id === id){
                item.interestTrack = interestTrack
            }
        })
        this.updateState({
            dateTime:newDateTime
        })
    };

    onEditorState = (explicitContent) => {
        this.updateState({explicitContent});
    };

    onEditorStateShort = (shortDescription) => {
        this.updateState({shortDescription});
    };

    onEditorStateLong = (longDescription) => {
        this.updateState({longDescription});
    };

    onInputShifId=(e,id)=>{
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {

            if (screeening._id === id) {
                screeening[name] =value;
                // screeening['locations'] = []
            }
        });

        this.updateState({})
        

    }
    handleImage = (e, id) => {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
          this.setState({
            file: file,
          },()=>
          {
            const fileList = Math.round((file && file.size / 1024));
            if (fileList > 10240) {        
              this.setState({
                errorPopup:true,
                errorMsg: 'Please upload a file smaller than 10MB'           
               })
                return false;
            } 
            if(file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ){
                setTimeout(() => {
                    this.imageUploadOne(file,id,event.target.result);
                  },0)
            }else{
                this.setState({
                    errorPopup:true,
                    errorMsg: 'Please upload a file for PNG,JPG or JPEG'           
                })
            }      
        })
        }
    }

    imageUploadOne = (file,id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = {...this.state}
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet= commonImage(file,false,'',img)
        fileSet.then((value) => {
              this.state.images.forEach(image => {
                const imagePreloaderId = `imagePreloader_${id}`
                const newState = {...this.state}
                newState[imagePreloaderId] = false
                this.setState(newState)
                  if(image._id === id){
                      image.inSite = value
                  }
                  
              });
           this.updateState({})
          });
    };

    deleteImage(id){
        this.setState({
            deleteImagePopup:true,
            deleteImageId:id
        })
    }

    addDateAndTime = (item) => {
        let newDateAndTime = {};
        newDateAndTime = {
            _id:Math.random(),
            screeningType:  this.state.screeningType.find(item => item._id === '1'),
            locationType: { _id: '1', name: 'In-Person' },
            locations: [],
            date:new Date(),
            endDate:new Date(),
            eventiveId:"",
            waitListSlotValid:'',
            maxWaitListSlots:0,
            hideFromLive:false,
            supressVoting: false,
            openCaption: false,
            accessibility:[],
            interestTrack:[],
            passBuckets:[],
            isMyLibraryScreen:false,
            start: {
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            end: {
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            }
          }

          let oldDateAndTime = this.state.dateTime
          oldDateAndTime.push(newDateAndTime)
          this.updateState({
            dateTime: oldDateAndTime,
          });
    }

    removeDateAndTime = (index) => {
        swal({
            title: "Are you sure?",
            text: "You are about to remove a screening",
            icon: "warning",
            buttons: ['Cancel','Continue'],
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                var filteredscreening = this.state.dateTime.filter((item, i) => i !== index)
                this.updateState({
                    dateTime: filteredscreening
                });
            } else {
            }
        });
    }

    onChangeScreeningType = (e, parentId) => {
        const {name, value} =e.target 
        let ScreeningType = {}
        let myLibrary = ['6','7','8','9','10','11','12'];
        // if(name !== 'locationType'){
        //     ScreeningType = this.state.screeningType.find(item => item._id === value)
        // }
        this.state.dateTime.forEach((item, i) => {
            if(item._id === parentId){
                if(myLibrary.includes(value)){
                    item['locationType'] = {_id:'2',label:'Online'}
                    item['isMyLibraryScreen'] = true
                }
                else{
                    item['isMyLibraryScreen'] = false
                }
                item[name]={_id:value,label:name}
                // item.shift72Id = ''
                item['screeningEventiveId'] = name !== 'locationType' ? this.getEventiveTag(item.locationType._id,value) : this.getEventiveTag(value,item.screeningType._id)
                item.maxWaitListSlots = (value === '5' || value === 5) ? 0 : item?.locations ? item?.locations?.maxWaitListSlots : item?.maxWaitListSlots
            }
        })

        this.updateState({})
    }

    getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item=>{
            var location = {
                value: item._id, label: item.name, eventiveId: item.eventiveId, maxWaitListSlots:item?.maxWaitListSlots
            }
            return location 
        })
        
    }

    //Location Master Call
    locationOption = () => {
        var options = []
        this.state.location.forEach(item => {
                if(item._id !== '934e67c906e26dd0737c')
                options.push( { value: item._id, label: item.name, eventiveId:item.eventiveId, maxWaitListSlots:item?.maxWaitListSlots })  
            });
            return options
        }

    handleChangeLocation = (value, parentId) => {
        this.state.dateTime.forEach(screeening => {
            if(screeening._id === parentId){   
                if(value !== null || value && value.length !== 0) screeening.emptyLocationError = ''
                else screeening.emptyLocationError = 'Location is required for all screening times.'
                screeening.locations = value
                screeening.maxWaitListSlots = (screeening?.screeningType?._id !== '5' && screeening?.screeningType?._id !== 5) ? (screeening?.locations.length > 0 ? screeening?.locations[0]?.maxWaitListSlots : value && value?.maxWaitListSlots) : 0
            }
        });
    
        this.updateState({})
    }

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []
        this.state.film && this.state.film.accessibility && this.state.film.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name, eventiveId:item.eventiveId})
        });
        return options
    }

    getEventiveTag = (locationType,screeningType) => {
        let screening =[]
        let screenByType  =[]
        screenByType = this.state.film.screnningTypeList.filter(screen => screen.type === screeningType)
        screening = screenByType.length > 1 ? locationType === '1' ? screenByType[0] : screenByType[1] : screenByType[0]
        console.log('screenByType:::',screenByType,screening);
        return screening.eventiveTagId
    }

    onInputWaitList = (e, id) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === id) {
                screeening[name] = value;
                if(value.length > 3){
                    screeening['waitListSlotValid'] = 'Value cannot exceed 3 characters.'
                } else if(/[a-zA-Z!@#$%^&*()_+\[\]{};':"\\|,.<>\/?\-=]+/.test(value)){
                    screeening['waitListSlotValid'] = 'Value can only include numbers.'
                } else {
                    screeening['waitListSlotValid'] = ''
                }
            }
        });
        this.updateState({})
    }

    TabClick = index => {
        this.setState({
          activetab: index
        }, () => {
            this.props.CurrentShortTab(index)
            this.props.history.push('/short-program-list')
        });
    }

    handleChangeGenre = selectedOptionGenre => {
        this.updateState({
            genre: []
        })
        this.updateState({
            genre: selectedOptionGenre
        });
    };

    handleChangenInterestTrack = interestTrack => {
        this.updateState({
            interestTrack: []
        })
        this.updateState({
            interestTrack: interestTrack
        })
    };

    //Genre Master Call
    genreOption = () => {
        var options = []
        this.state.film && this.state.film.genre && this.state.film.genre.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Interest Track Master Call
    interestTrackOption = () => {
        var options = []
        this.state.film && this.state.film.interestTrack && this.state.film.interestTrack.forEach(item => {
            options.push({ value: item._id, label: item.name, eventiveId: item.eventiveId })
        });
        return options
    }

    render() {
        
        const { ShortProgramList, dropList, film, shortProgrammeFilms, getLastUpdated } = this.state
        let myLibrary = ['6','7','8','9','10','11','12'];
        var settings = {
            customPaging: function(i) {
                return (
                  <a>{i + 1}</a>
                );
              },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
          };
        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const minutes = [
            { value: '00', label: '00' },
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const state = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]

        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt)
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy
        return (
            <React.Fragment>
                {/* <MainLayout history={this.props.history}> */}
                <div className="right_side_wrapper relative">
                {this.state.loaderFlag ?  <Loader /> : ''}
                {/* {this.state.shortPopUp ?  <span className="popup_overlay" onClick={() => this.HideShortPopUp}> </span> :''} */}
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list,index) => {
                                return(
                                    <li className={this.state.activetab === index ? 'active' : '' }>
                                        <p>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => this.TabClick(index)}>
                                            <div style={{ paddingRight: '10px',position:'relative' }}>{list.label}</div>
                                            </div>
                                            <span id= {index} onClick={(e)=>this.clearAllForm(e)}><PlusIcon /></span>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to='/short-program-list'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List</Link>
                        {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                            <p className="update_date">Last Update: {moment(updateAt).format('h')}:{moment(updateAt).format('mm')} {moment(updateAt).format('A')} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                        }
                    </div>
                    <RecordPresenceBanner activeViewers={this.props.recordViewers} conflict={this.props.recordConflict} />
                    <div className="program_main fpg_tabcontent ">
                        <form>
                            <div className="d_flex">
                                <div className="program_left mt_0">
                                    <div className="program_title_input  d_flex d_flex_justify_spacebt mb_10">
                                        <div className="field_row horizontal_field short_film">
                                            <TextField
                                                label="Program"
                                                type="text"
                                                placeholder="Episodic Pilot Showcase 1"
                                                name='name'
                                                id='name'
                                                value={this.state.name}
                                                onChange={this.onInputChange}
                                            />
                                             <span style={{ color: 'red' }}>{this.validator.message('name', this.state.name, 'required')}</span>
                                        </div>
                                        <div className="field_row horizontal_field access_data no_bg_dropdown">
                                            <DropdownMaster
                                                label="Access"
                                                options={
                                                    film && film.access
                                                }
                                                name='access'
                                                value={this.state.access.value}
                                                onChange={this.dropChange}
                                                fpgerror={this.validator.message('access', this.state.access.value, 'required')}
                                            />
                                        </div>
                                    </div>
                                    <div className="short_program_img">
                                        <Slider {...settings} >
                                           {this.state.images.map((item,i) => {
                                                const imagePreloaderState = `imagePreloader_${item._id}`
                                               return(
                                            <div>
                                                <div className="media_image mb_0 absolute_loader" style={{position: 'relative', height: '223px'}}>
                                                {this.state[imagePreloaderState] ?
                                                <Loader/>
                                                : 
                                                <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : '/images/image-placeholder.png'} alt="image"/>
                                                }
                                                    <UploadForm item={item} handleImage={(e)=>this.handleImage(e,item._id)} deleteImage={()=>this.deleteImage(item._id)} iconDelete={true}/>
                                                </div> 
                                            </div>
                                            )
                                        })}
                                        </Slider>
                                    </div>
                                <div class="relative  static_pagination"></div>
                                    <div className="program_header d_flex">
                                        <h3>Episodics Included in Program</h3>
                                        <span onClick={this.AddShort}>Add Episodic + </span>
                                    </div>
                                    <div className="program_inner">
                                        <DragDropContext onDragEnd={this.onDragEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <ul {...provided.droppableProps} ref={provided.innerRef} >
                                                        {shortProgrammeFilms.map((item, index) => {
                                                            return (
                                                                <Draggable
                                                                    key={item && item.film && item.film._id}
                                                                    draggableId={`'${item && item.film && item.film._id}'`}
                                                                    index={index}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <li
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}>
                                                                            <div className="d_flex list_inner d_flex_align_center">
                                                                                <DragIcon />

                                                                                <div className="program_contents d_flex">
                                                                                    <div className="program_image">
                                                                                        <img src={
                                                                                            item && item.film && item.film.images && item.film.images.inSite ? this.apiserve.imageUrl + item.film.images.inSite :
                                                                                                item && item.film && item.film.images && item.film.images.link ? item && item.film && item.film.images && item.film.images.link
                                                                                                    : '/images/image-placeholder.png'} />
                                                                                    </div>
                                                                                    <div className="program_contents_desc">
                                                                                        <h2 className="program_title">{item && item.film && item.film.title}</h2>
                                                                                        <p className="program_time">{item && item.film && item.film.runTime} min</p>
                                                                                        <select  value={item.film.isUnavailable}
                                                                                            name='isUnavailable'
                                                                                            onChange={(e) => this.handleUnavailable(e, item && item.film && item.film._id)}>
                                                                                            {SHORT_FILM_AVAILIBILITY.map((option) => {
                                                                                                return (
                                                                                                    <option key={option.value} value={option.value} selected={item.film.isUnavailable === option.value ? 'selected' : ''}>{option.label}</option>
                                                                                                )
                                                                                                })
                                                                                            }
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                                <span className="pointer" onClick={(e) => this.removeShortProgram(e, item && item.film && item.film._id)}>
                                                                                    <FpgMinusIcon width="20" height="20" color="#4F4F4F" />
                                                                                </span>
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                </Draggable>
                                                            )
                                                        })}
                                                    </ul>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                                <div className="program_right">
                                    <div className="program_date_time">
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Genre</label>
                                                <div className="select_field relative">
                                                    <Select
                                                        isMulti
                                                        onChange={this.handleChangeGenre}
                                                        options={this.genreOption()}
                                                        value={this.state && this.state.genre}
                                                    />
                                                </div>
                                            </div>
                                            <span className="error select_error">{this.validator.message('genre', this.state.genre, 'required')}</span>
                                        </div>
                                        <div className="pb_15"></div>
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Interest Tracks</label>
                                                <div className="select_field relative">
                                                    <Select
                                                        isMulti
                                                        onChange={this.handleChangenInterestTrack}
                                                        options={this.interestTrackOption()}
                                                        value={this.state && this.state.interestTrack}
                                                    />
                                                </div>
                                            </div>
                                            <span className="error select_error">{this.validator.message('interest track', this.state.interestTrack, 'required')}</span>
                                        </div>
                                        <h2 className='mt_15 mb_15'>Screenings</h2>  
                                        <div className="field_row relative" style={{zIndex:"3"}} onClick={() => this.HideShortPopUp()}>
                                            {this.state?.dateTime?.map((item, i) => {
                                                return (
                                                    <div className='field_row screening_info_row'>
                                                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                <label>Event Start Date & Time (MT)</label>

                                                                <div className="form_group_countdown" key={i}>
                                                                    <TextField type="text" name="date"
                                                                        value={moment(item.date).format(
                                                                            "MM/DD/YYYY"
                                                                        )}
                                                                        placeholder="mm / dd / yyyy"
                                                                    />

                                                                    <span className="calendar_img">
                                                                        {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                        <DatePicker
                                                                            selected={item.date}
                                                                            onChange={(e) => this.handleChangeDate(e, item._id,'startDate')}
                                                                            minDate={moment().toDate()}
                                                                            placeholder="mm/dd/yyyy"
                                                                            customInput={
                                                                                <span className="calendar">
                                                                                    <CalendarIcon />
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </span>

                                                                    <Select
                                                                        options={hours}
                                                                        value={item.start.hours}
                                                                        name='hours'
                                                                        placeholder="7"
                                                                        onChange={(e) => this.handleTimeStartHours(e, i)} />
                                                                    <Select
                                                                        options={minutes}
                                                                        value={item.start.minutes}
                                                                        name='minutes'
                                                                        placeholder="30"
                                                                        onChange={(e) => this.handleTimeStartMin(e, i)} />
                                                                    <Select
                                                                        options={state}
                                                                        value={item.start.state}
                                                                        name='state'
                                                                        placeholder="AM"
                                                                        onChange={(e) => this.handleTimeStartStamps(e, i)} />
                                                                </div>
                                                                <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                                    {i === 0 ? (
                                                                        <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                        </span>
                                                                    )
                                                                        :
                                                                        (
                                                                            <>
                                                                                <span className="pointer" onClick={() => this.removeDateAndTime(i)}>
                                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                </span>
                                                                                <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                </span>
                                                                            </>
                                                                        )
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center">
                                                            <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                <label>Event End Date & Time (MT)</label>

                                                                <div className="form_group_countdown" key={i}>
                                                                    <TextField type="text" name="date"
                                                                        value={moment(item.endDate).format(
                                                                            "MM/DD/YYYY"
                                                                        )}
                                                                        placeholder="mm / dd / yyyy"
                                                                    />

                                                                    <span className="calendar_img">
                                                                        {/* <img src={calendar} alt="calendar icon" title="calendar icon"/>   */}
                                                                        <DatePicker
                                                                            selected={item.endDate}
                                                                            onChange={(e) => this.handleChangeDate(e, item._id, 'endDate')}
                                                                            minDate={moment(this.state.dateTime.find((e) => e._id === item._id).start.date).toDate()}
                                                                            placeholder="mm/dd/yyyy"
                                                                            customInput={
                                                                                <span className="calendar">
                                                                                    <CalendarIcon />
                                                                                </span>
                                                                            }
                                                                        />
                                                                    </span>

                                                                    <Select
                                                                        options={hours}
                                                                        value={item.end.hours}
                                                                        name='hours'
                                                                        placeholder="7"
                                                                        onChange={(e) => this.handleTimeEndHours(e, i)} />
                                                                    <Select
                                                                        options={minutes}
                                                                        value={item.end.minutes}
                                                                        name='minutes'
                                                                        placeholder="30"
                                                                        onChange={(e) => this.handleTimeEndMin(e, i)} />
                                                                    <Select
                                                                        options={state}
                                                                        value={item.end.state}
                                                                        name='state'
                                                                        placeholder="AM"
                                                                        onChange={(e) => this.handleTimeEndStamps(e, i)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                            <div className="field_row">
                                                <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                    <label></label>
                                                    <DropdownMaster 
                                                        name="locationType" 
                                                        onChange= {(e) => this.onChangeScreeningType(e,item._id)}
                                                        value={item && item.locationType && item.locationType._id}
                                                        options={ item.isMyLibraryScreen || myLibrary.includes(item.screeningType?._id) ? this.state.locationType1 : this.state.locationType}
                                                    />
                                                    <div className="ml_15">
                                                        {/* {this.state.filmId ?  */}
                                                        {/* <DropdownMaster 
                                                            name="screeningType" 
                                                            onChange= {(e) => this.onChangeScreeningType(e,item._id)}
                                                            value={item && item.screeningType && item.screeningType._id}
                                                            options={this.state.screeningType}
                                                        />  */}
                                                        <DropdownMasterScreening 
                                                            name="screeningType"
                                                            onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                                            value={item && item.screeningType && item.screeningType._id}
                                                            // options={this.state.screeningType}
                                                            options={this.state.screeningType?.filter((e) => e.locationType === item.locationType._id).sort((a,b) => a.sortIndex - b.sortIndex)}
                                                            defaultValue={this.state.screeningType?.filter((e) => e.locationType === item.locationType._id).sort((a,b) => a.sortIndex - b.sortIndex)[0]}
                                                        />    
                                                    </div> 
                                                </div> 
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Accessibility</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={(e) => this.handleChangenAccessibilityScreening(e, item._id)}
                                                                options={this.accessibilityOption()}
                                                                value={item.accessibility}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Interest Tracks</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={(e) => this.handleChangenInterestTrackScreening(e, item._id)}
                                                                options={this.interestTrackOption()}
                                                                value={item.interestTrack}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field d_flex">
                                                    <div className="field_row_inner">
                                                        <label>Hide From Live</label>
                                                        <div className="relative mt_10">
                                                            <div className="checkbox_field_row">
                                                                <div className="checkBox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`hideFromLive_`+i}
                                                                        name={`hideFromLive`}
                                                                        checked={item.hideFromLive}
                                                                        onChange={(e) => this.handleLiveCheck(e, item._id)} />
                                                                    <label for={`hideFromLive_`+i} style={{ width: "auto" }}></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field_row_inner">
                                                        <label>Supress Voting</label>
                                                        <div className="relative mt_10">
                                                            <div className="checkbox_field_row">
                                                                <div className="checkBox">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`supressVoting_`+i}
                                                                        name={`supressVoting`}
                                                                        checked={item.supressVoting}
                                                                        onChange={(e) => this.handleLiveCheck(e, item._id)} />
                                                                    <label for={`supressVoting_`+i} style={{ width: "auto" }}></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    {<div className="field_row ">
                                                        <div className="form_group_shift d_flex mb_0 horizontal_field d_flex_align_center">
                                                            <span className="id_text d_flex d_flex_align_baseline"><label>Maximum Waitlist Slots :</label>
                                                                <div className="field_row mb_0">
                                                                    <TextField
                                                                        type="text"
                                                                        pattern="[0-9]*"
                                                                        name="maxWaitListSlots"
                                                                        id={item._id}
                                                                        value={item.maxWaitListSlots}
                                                                        onChange={(e) => this.onInputWaitList(e, item._id)}
                                                                    />
                                                                </div>
                                                            </span>
                                                        </div>
                                                        <span className='error srv-validation-message' style={{ color: 'red' }}>{item.waitListSlotValid}</span>
                                                    </div>}
                                                </div>
                                                {
                                                    <div className="field_row horizontal_field mt_10">
                                                        <TextField
                                                            label='Eventive ID'
                                                            type='text'
                                                            name="eventiveId"
                                                            id="eventiveId"
                                                            value={item?.eventiveId}
                                                            disable={true}
                                                        />
                                                    </div>}        
                                            
                                        {
                                            item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3" ?
                                            <>
                                            <div className="field_row horizontal_field">
                                                <div className="d_flex mb_0 d_flex_align_center">
                                                    <label></label>
                                                    <div className="field_row horizontal_field width_265">
                                                        <div className="field_row_inner">
                                                            <label>Location</label>
                                                            <div className="select_field relative"> 
                                                                <Select
                                                                    // isMulti
                                                                    name="locations"
                                                                    onChange= {(e) => this.handleChangeLocation(e,item._id)}
                                                                    options={this.locationOption()}
                                                                    value={item && item.locations}
                                                                />
                                                            </div>
                                                            { (item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3") && <span className="error srv-validation-message" style={{ color: 'red' }}>{item.emptyLocationError}</span> }
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                            </>
                                            : ''
                                        }
                                        {/* <div className="field_row horizontal_field">
                                        <div className="disp_flex ">
                                                <label>Shift72 ID: </label>
                                                <div className="field_input relative">
                                                    <input 
                                                        type="text" 
                                                        placeholder="123122"
                                                        name="shift72Id"
                                                        id={item._id}
                                                        value={item.shift72Id}
                                                        onChange={(e) => this.onInputShifId(e,item._id)}/>
                                                </div>
                                            </div>
                                        </div> */}
                                        </div>
                                             )
                                            })}
                                        </div>
                                        {/* <div className="field_row horizontal_field">
                                        <div className="disp_flex ">
                                                <label>Shift72 ID: </label>
                                                <div className="field_input relative">
                                                    <input 
                                                        type="text" 
                                                        placeholder="123122"
                                                        name="shift72Id"
                                                        value={this.state.shift72Id}
                                                        onChange={this.onInputChange} />
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="field_row horizontal_field">
                                                <div className="field_row_inner">
                                                    <label>Run Time</label>
                                                    <div className="field_input relative run_time_field">
                                                        <div className="disp_flex d_flex_align_center">
                                                            <input 
                                                                type="number" 
                                                                name="runTime" 
                                                                id="runTime"
                                                                value={this.state.runTime} 
                                                                placeholder=""
                                                                onChange={this.onInputChange}
                                                            />
                                                            <label className="ml_5">min</label>
                                                        </div>
                                                        {/* {fpgerror ? {fpgerror}</span> : ''} */}
                                                        <span className="error">{this.validator.message('runTime', this.state.runTime, 'required')}</span>
                                                    </div>
                                                </div>


                                            </div>
                                        <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                        <div className="relative mt_5">
                                                <div className="checkbox_field_row">
                                                    <div className="checkBox">
                                                        <input 
                                                            type="checkbox"
                                                            id="isSponsor" 
                                                            name="isSponsor" 
                                                            checked={this.state.isSponsor}
                                                            onChange={(e) => this.handleCheck(e)} />
                                                        <label for="isSponsor" style={{width:"auto"}}></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <label style={{width:"235px"}}>Episodic Program Sponsor</label>
                                         
                                         
                                        </div>    
                                        
                                    </div> 

                                        <div className="field_row horizontal_field small_file_upload">
                                        <div className="field_row_inner">
                                            <label>Sponsor Logo</label>
                                            <div className="field_input relative">
                                                <div className="media_image mb_0 absolute_loader relative">
                                                    {this.state.ImagePreloaderSponsorLogo ?
                                                        <Loader/>
                                                        :
                                                        <img src={this.state.sponsorLogo ? this.apiserve.imageUrl + this.state.sponsorLogo : '/images/image-placeholder2.png'} alt="image"/>
                                                    }
                                                    <div className={`input_file ${this.state.sponsorLogo ? 'active' : ''}`}>
                                                    <input id="myInput"
                                                        type="file"
                                                        ref={(ref) => this.uploadSponsorLogo = ref}
                                                        style={{display: 'none'}}
                                                        onChange={this.handleImageSponsorLogo.bind(this)}
                                                        accept=".png, .jpg, .jpeg"
                                                    />
                                                        <span onClick={()=>{this.uploadSponsorLogo.click()}}><AddFileIcon /></span>
                                                    </div>
                                                    {this.state.sponsorLogo &&
                                                        <span className="remove_file pointer" onClick={()=>this.deleteImageSponsorLogo()}><DeletefileIcon /></span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field">
                                    <div className="field_row_inner">
                                    <label>Explicit Content</label>
                                        <div className="relative mt_5">
                                                <div className="checkbox_field_row">
                                                    <div className="checkBox">
                                                        <input 
                                                            type="checkbox"
                                                            id="isExplicitContent" 
                                                            name="isExplicitContent" 
                                                            checked={this.state.isExplicitContent}
                                                            onChange={(e) => this.handleCheck(e)} />
                                                        <label for="isExplicitContent" ></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                    <div className="field_row horizontal_field relative" style={{zIndex:"1"}}>
                                    <div className="field_row_inner">
                                    <label>Short Description</label>
                                        <div className="field_row editor_400">
                                                <TextEditor
                                                    name="shortDescription"
                                                    editorState={this.state.shortDescription}
                                                    value={this.state.shortDescription}
                                                    onEditorStateChange={(e) =>
                                                    this.onEditorStateShort(e)}
                                                />
                                        </div>
                                        </div>
                                    </div><div className="field_row horizontal_field relative" style={{zIndex:"1"}}>
                                    <div className="field_row_inner">
                                    <label>Long Description</label>
                                        <div className="field_row editor_400">
                                                <TextEditor
                                                    name="longDescription"
                                                    editorState={this.state.longDescription}
                                                    value={this.state.longDescription}
                                                    onEditorStateChange={(longDescription) =>
                                                    this.onEditorStateLong(longDescription)}
                                                />
                                        </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field relative" style={{zIndex:"1"}}>
                                    <div className="field_row_inner">
                                    <label>Explicit Content Disclaimer</label>
                                        <div className="field_row editor_400">
                                                <TextEditor
                                                    name="explicitContent"
                                                    editorState={this.state.explicitContent}
                                                    value={this.state.explicitContent}
                                                    onEditorStateChange={(e) =>
                                                    this.onEditorState(e)}
                                                />
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="text_center field_row w_100 buttons_outer mb_0">
                                    <button className="uppercase" type='button' onClick={(e) => this.backToListShortProgram(e)}>CANCEL</button>
                                    <button className="uppercase prev_btn" type='button' onClick={(e) => this.submitShortProgram(e,true)}>PREviEW</button>
                                    <button className={`uppercase ${this.state.programDisabled || (!!this.props.episodicShortProgramId && !this.state.episodicProgramEdited) ? '' : 'active'}`} type='button' onClick={(e) => this.submitShortProgram(e,false)} disabled={this.state.programDisabled || (!!this.props.episodicShortProgramId && !this.state.episodicProgramEdited)}>SAVE</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    

                </div>
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                }
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
                {this.state.errorScreeningPopup ?
                    <ErrorScreeningPopUp
                        errorMsg={this.state.errorData}
                        errorMsgPopup={this.errorMsgPopupOk}
                    />
                    : ''
                }

                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                    HeaderName="Delete Image?"
                    insideDetails="Are You Sure ?"
                    insideData="You want to delete this image"
                    popupState={this.closeAdminUser}
                    yesPopUp={this.deleteImagePopup}
                />
                ) : (
                    ""
                )}
                {
                        this.state.selectshort ?
                            <>
                                <span className="popup_overlay" onClick={() => this.HideShortPopUp()}> </span>
                                <div className="program_popup" style={{zIndex:"9999"}}>
                                <div className="program_popup_header d_flex d_flex_justify_spacebt d_flex_align_center">
                                    <span className="header_title">Select Shorts</span>
                                    <div className="relative field_row mb_0">
                                        <div className="field_input">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                id="searchField"
                                                name="searchField"
                                                value={this.state.searchField}
                                                onChange={this.onSearchFilter} />
                                            <span className="pointer search_icon" type='button' style={{ pointerEvents: 'none' }}><SearchIcon /></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="popup_content" style={{maxHeight: '80vh', overflow: 'auto'}}>
                                    {dropList.map((item, i) => {
                                        return (
                                            <>
                                                <div className="customCheckBox">
                                                    <CheckBox name='selectShortFilm'
                                                        // name={item.title}
                                                        value={item.value === "true" ? true : false}
                                                        onChange={(e) => this.shortProgramCheck(e, item)}
                                                        label={item.title}
                                                        type="checkbox"
                                                        id={item.title}
                                                    />
                                                </div>
                                            </>
                                        )

                                    })}
                                </div>


                                <div className="field_row text_center pt_25">
                                    <button onClick={this.CancleShort}> CANCEL</button>
                                    <button className="active" type='button' onClick={(e) => this.selectedShortFilm(e)}>SUBMIT</button>
                                </div>
                            </div>
                            </>
                            :
                            ""
                    }
                <ConflictSaveModal
                    isVisible={this.state.showConflictModal}
                    conflict={this.props.recordConflict}
                    onClose={() => this.setState({ showConflictModal: false })}
                />
                {/* </MainLayout> */}
            </React.Fragment>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EpisodicProgramCreate);